import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import { KineticTheme } from 'config/themes';
import {
  ATT,
  Astound,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  Comcast,
  Cox,
  Spectrum,
  Optimum,
  WOW,
  TDS,
  BuckeyeBroadband,
  Mediacom,
  FidiumFiber,
} from 'config/providers';

export const KineticSpecial: SingleProviderConfig = {
  name: 'KineticSpecial',
  micrositeCode: 'Windstream', // Not changed during rebrand from Windstream -> Kinetic
  mainProvider: Windstream,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'kineticspecial.com',
  homepage: 'https://kineticspecial.com',
  title: 'Kinetic Authorized Dealer',
  fallbackPhoneNumber: '855-446-1939',
  fallbackLeadModePhoneNumber: '800-972-6964',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: KineticTheme,
  needsDcSession: false,
  source: 'KineticSpecial',
  noOffersRetry: 2,
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-cart.kineticspecial.com/guest/tvi/buy',
    qa: 'https://staging-cart.kineticspecial.com/guest/tvi/buy',
    production: 'https://cart.kineticspecial.com/guest/tvi/buy',
  },
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: asyncEligible,
  crossSellProviders: [
    ATT,
    Verizon,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    CincinnatiBell,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    Comcast,
    Cox,
    Spectrum,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
    Mediacom,
    FidiumFiber,
  ],
};
